import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import { DetailComponent } from './../detail/detail.component';
import {ActivatedRoute} from '@angular/router';
import {ConfService} from '../../conf.service';
import {SettingsComponent} from '../../settings/settings.component';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

@Component({
    selector: 'app-connector',
    templateUrl: './connector.component.html',
    styleUrls: ['./connector.component.scss']
})
export class ConnectorComponent implements OnInit {

    @ViewChild(DetailComponent) detail: DetailComponent;

    title = 'API Integrators';
    cardType = 'connector';
    buttonType = 'connector';
    categories: any;
    partner: any;
    account: any;
    flag = false;
    category_id: any;
    specificCategory: any;
    specificCategorytemp: any;
    categorytemp: any;
    producers: any;
    producersTemp: any;

    screenWidth: any;
    screenHeight: any;
    cellsToShow: any;
    carouselWidth: any;
    cellsToScroll: any;

    apiConnectors = [
        {
            title : 'Slack',
            image : './assets/img/slack.png',
            caption : '',
            connect : '',
            view : ''
        },
        {
            title : 'JIRA',
            image : './assets/img/jira.png',
            caption : '',
            connect : '',
            view : ''
        },
        {
            title : 'ServiceNow',
            image : './assets/img/servicenow.jpg',
            caption : '',
            connect : '',
            view : ''
        },
        {
            title : 'Salesforce',
            image : './assets/img/salesforce.jpg',
            caption : '',
            connect : '',
            view : ''
        },
        {
            title : 'DocuSign',
            image : './assets/img/docusign.png',
            caption : '',
            connect : '',
            view : ''
        },
        {
            title : 'AWS',
            image : './assets/img/aws.jpg',
            caption : '',
            connect : '',
            view : ''
        },
        {
            title : 'Google',
            image : './assets/img/google.png',
            caption : '',
            connect : '',
            view : ''
        },
        {
            title : 'Kong',
            image : './assets/img/kong.jpg',
            caption : '',
            connect : '',
            view : ''
        },
        {
            title : 'Microsoft',
            image : './assets/img/microsoft.png',
            caption : '',
            connect : '',
            view : ''
        },
        {
            title : 'IBM',
            image : './assets/img/ibm.jpg',
            caption : '',
            connect : '',
            view : ''
        }
    ];

    consoleData = [
        {
            title: 'Partner Settings',
            cards: [
                {
                    id: 0,
                    title: 'Business Locations',
                    description: null,
                    image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/earth.png',
                    link: ['/', 'businesslocations'],
                    percentage: 0,
                },
                {
                    id: 1,
                    title: ' Business Details',
                    description: 'Include details such GST and PAN number, partner organization, partner organization type, secondary phone number, and email.',
                    image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/businessdetails.png',
                    link: ['/', 'businessdetails'],
                    percentage: null,
                },
                {
                    id: 2,
                    title: 'Branding',
                    description: 'Customize the platform\'s appearance by modifying the page title, colours, and logos.',
                    image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/branding.png',
                    link : ['/', 'branding'],
                    percentage: null
                }
            ]
        },
        {
            title: 'Identity and Access Management',
            cards: [
                {
                    id: 0,
                    title: 'Users',
                    description: 'Manage Users',
                    link: [],
                    image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/users.png',
                    percentage: null
                },
                {
                    id: 1,
                    title: 'User Groups',
                    description: 'Manage User Groups',
                    link: [],
                    image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/usergroup.png',
                    percentage: null
                },
                {
                    id: 2,
                    title: 'Roles',
                    description: 'Manage Roles',
                    link: [],
                    image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/roles.png',
                    percentage: null
                },
                {
                    id: 3,
                    title: 'Consumers',
                    description: 'Manage Consumers',
                    link: [],
                    image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/consumer.png',
                    percentage: null
                },
            ]
        },
        {
            title: 'Environments',
            cards: [
                {
                    id: 0,
                    title: 'Environments',
                    link: [],
                    description: 'environment',
                    image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/environment.png',
                    percentage: null
                }
            ]
        }
    ];

    businessLocation = {
        address_line_1: false,
        address_line_2: false,
        city: false,
        state: false,
        country: false,
        pincode: false,
        localization: false
    };

    // businessDetails = {
    //     partner_organization: false,
    //     partner_organization_type: false,
    //     secondary_email: false,
    //     secondary_phone: false,
    //     GST: false,
    //     PAN: false,
    // };
    //
    // branding = {
    //     favIconPayload: false,
    //     logoMarkPayload: false,
    //     brandImagePayload: false,
    // };

    componentIsLoading = true;

    constructor(
        public settingComp: SettingsComponent,
        public platform: LeftpanelComponent,
        private route: ActivatedRoute,
        private confPost: ConfService) { }

    ngOnInit(): void {
        this.initializeData();
        //     this.confPost.getData('services', 'services', 'v1', 'producerCategories', 'partner=services,' + localStorage.getItem('partner') + '&account=services,' + localStorage.getItem('account')).subscribe(response => {
    //         this.categories = response;
    //         this.confPost.getData('services', 'services', 'v1', 'producerCategories', 'partner=services,' + localStorage.getItem('partner') + '&account=services,' + localStorage.getItem('account') + '&dbref=false').subscribe(response1 => {
    //             this.categorytemp = response1;
    //             this.route.queryParams.subscribe(params => {
    //                 if (params.partner !== undefined && params.category !== undefined) {
    //                     this.partner = params.partner;
    //                     this.account = params.partner;
    //                     this.category_id = params.category;
    //                     for (let i = 0; i < this.categories.length; i++) {
    //                         if (this.categories[i].id === parseInt(this.category_id, 10)) {
    //                             this.specificCategory = this.categories[i];
    //                         }
    //                     }
    //                     for (let i = 0; i < this.categorytemp.length; i++) {
    //                         if (this.categorytemp[i].id === parseInt(this.category_id, 10)) {
    //                             this.specificCategorytemp = this.categorytemp[i];
    //                         }
    //                     }
    //                     this.specificCategory['currentServiceProvider'] = [];
    //                     this.confPost.getData('services', 'services', 'v1', 'apiproducers', 'partner=services,' + localStorage.getItem('partner') + '&account=services,' + localStorage.getItem('account')).subscribe(response => {
    //                         this.producers = response;
    //                         this.producersTemp = JSON.parse(JSON.stringify(this.producers));
    //                         let temp = [];
    //                         let flag: boolean;
    //                         let flag1: boolean;
    //                         for (let k = 0; k < this.producersTemp.length; k++) {
    //                             flag = false;
    //                             flag1 = false;
    //                             for (let i = 0; i < this.specificCategory.serviceProvider.length; i++) {
    //                                 if (this.producersTemp[k].id === this.specificCategory.serviceProvider[i].id) {
    //                                     flag = true;
    //                                 }
    //                                 if (this.producersTemp[k].id === this.specificCategory.serviceProvider[i].id
    //                                     && this.producersTemp[k].account === this.specificCategory.serviceProvider[i].account
    //                                     && this.producersTemp[k].partner === this.specificCategory.serviceProvider[i].partner
    //                                     && this.producersTemp[k].account !== null && this.producersTemp[k].partner !== null) {
    //                                     flag1 = true;
    //                                 }
    //                             }
    //                             if (flag === false) {
    //                                 temp.push(this.producersTemp[k]);
    //                             }
    //                             if (flag1) {
    //                                 this.specificCategory.currentServiceProvider.push(this.producersTemp[k]);
    //                             }
    //                         }
    //                         this.producers = temp;
    //                         this.flag = true;
    //                     });
    //                 } else {
    //                     this.category_id = '';
    //                 }
    //             });
    //         });
    //     });
    //
    //     this.screenHeight = window.innerHeight;
    //     this.screenWidth = window.innerWidth;
    //
    //     this.cellsToScroll = 3;
    //     this.cellsToShow = 6;
    //     this.carouselWidth = 1400;
    }

    initializeData() {

        if (!this.settingComp.item) {
            Promise.resolve(this.settingComp.setcolumnvalues()).then(res => {
                const businessLocationPercentage = this.checkDetails(Object.keys(this.businessLocation), this.businessLocation);
                this.consoleData[0].cards[0].percentage = businessLocationPercentage;
                // const businessDetailsPercentage = this.checkDetails(Object.keys(this.businessDetails), this.businessDetails);
                // this.consoleData[0].cards[1].percentage = businessDetailsPercentage;
                this.componentIsLoading = false;
            });
        } else {
            Promise.resolve(this.settingComp.setcolumnvalues()).then(res => {
                const businessLocationPercentage = this.checkDetails(Object.keys(this.businessLocation), this.businessLocation);
                this.consoleData[0].cards[0].percentage = businessLocationPercentage;
                // const businessDetailsPercentage = this.checkDetails(Object.keys(this.businessDetails), this.businessDetails);
                // this.consoleData[0].cards[1].percentage = businessDetailsPercentage;
                this.componentIsLoading = false;
            });
        }
        const partner = this.getPartner();
        for (const card of this.consoleData[1].cards) {
            if (card.title === 'Users') {
                card.link = ['/users'];
            } else if (card.title === 'User Groups') {
                card.link = ['/user-groups'];
            } else if (card.title === 'Roles') {
                card.link = ['/admin-roles'];
            } else if (card.title === 'Consumers') {
                card.link = ['/consumers'];
            }
        }
        for (const card of this.consoleData[2].cards) {
            if (card.title === 'Environments') {
                card.link = ['/dev-environments'];
            }
        }
    }
    getPartner() {
        if (localStorage.getItem('partner')) {
            return localStorage.getItem('partner');
        }
    }

    getAccount() {
        if (localStorage.getItem('account')) {
            return localStorage.getItem('account');
        }
    }

    getEmail() {
        if (localStorage.getItem('signInEmail')) {
            return localStorage.getItem('signInEmail');
        }
    }

    checkDetails(checkList: any, dataList: any) {
        if (this.settingComp.item) {
            let filledDetails = 0;
            for (const field of checkList) {
                if ( this.settingComp.item[field] && this.settingComp.item[field] !== '') {
                    filledDetails = filledDetails + 1;
                    dataList[field] = true;
                } else {
                    dataList[field] = false;
                }
            }
            return this.calculatePercentage(checkList, filledDetails);
        }
        return 0;
    }

    calculatePercentage(checkList: any, filled: any) {
        return Math.round((filled / checkList.length) * 100);
    }

    // @HostListener('window:resize', ['$event'])
    //
    // onResize(event) {
    //     this.screenWidth = window.innerWidth;
    //     this.screenHeight = window.innerHeight;
    //
    //     if (this.screenWidth < 1655) {
    //         this.cellsToShow = 4;
    //         this.carouselWidth = 1000;
    //         this.cellsToScroll = 3;
    //     }
    //     if (this.screenWidth < 1256) {
    //         this.cellsToShow = 3;
    //         this.carouselWidth = 800;
    //         this.cellsToScroll = 1;
    //     }
    //     if (this.screenWidth < 978) {
    //         this.cellsToShow = 2;
    //         this.carouselWidth = 600;
    //         this.cellsToScroll = 1;
    //     }
    //     if (this.screenWidth < 705) {
    //         this.cellsToShow = 1;
    //         this.carouselWidth = 400;
    //         this.cellsToScroll = 1;
    //     }
    //     if (this.screenWidth > 1655) {
    //         this.cellsToShow = 6;
    //         this.carouselWidth = 1400;
    //         this.cellsToScroll = 3;
    //     }
    // }
}
